import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { ActionButtonsWrapper, ActionButton } from '../styles'
import type {
  AnyVisualization,
  ButtonsPanelButton,
  ButtonsPanelButtonVariant,
  ButtonsPanelRouteButton,
} from '../visualization.types'

const Container = styled.div`
  padding: 0 16px 16px 16px;
`

interface ButtonPanelProps {
  visualization: Extract<AnyVisualization, { renderer: 'buttons' }>
  onButtonClick?: (button: ButtonsPanelButton) => void
}

const resolveVariant = (button: ButtonsPanelButton): ButtonsPanelButtonVariant => {
  if (button.variant) return button.variant
  if (button.type === 'export') return 'primary'
  return 'neutral'
}

function isRouteButton(button: ButtonsPanelButton): button is ButtonsPanelRouteButton {
  return button.type === 'route' && typeof button.path === 'string'
}

export default function ButtonsPanel({ visualization, onButtonClick }: ButtonPanelProps) {
  const navigate = useNavigate()

  const buttons = visualization.payload.buttons

  const handleButtonClick = (button: ButtonsPanelButton) => {
    if (button.disabled) return

    if (isRouteButton(button)) {
      navigate(button.path)
      onButtonClick?.(button)
      return
    }

    onButtonClick?.(button)
  }

  return (
    <Container>
      <ActionButtonsWrapper>
        {buttons.map(button => {
          const variant = resolveVariant(button)
          return (
            <ActionButton
              key={button.label}
              $variant={variant}
              disabled={Boolean(button.disabled)}
              onClick={() => handleButtonClick(button)}
            >
              <span>{button.label}</span>
            </ActionButton>
          )
        })}
      </ActionButtonsWrapper>
    </Container>
  )
}
